export default __webpack_public_path__ + "images/ab821185f68ccf52b68202f934320d59.svg";